<template>
  <div class="bg_image" :style="{ backgroundImage: 'url(' + imagenIDtoSRC(obj.Imagen) + ')' }">
    <div class="breadcrumb-area rn-bg-color ptb--120 parallax d-flex align-center justify-center" data-black-overlay="2"
      :style="'-webkit-backdrop-filter: ' + obj.ImagenFiltro + ';backdrop-filter: ' + obj.ImagenFiltro + ';'">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div :class="'banner-section breadcrumb-inner-notin pt--100 pt_sm--40 pt_md--50'">
              <h1 >{{ obj.Titulo.Texto }}</h1>
              <h2 v-if="obj.Subtitulo !== ''">{{ obj.Subtitulo.Texto }}</h2>
              <a v-if="obj.ShowButton" class="rn-btn" :to="obj.Button.Click">
                {{ obj.Button.Texto }}
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { useStore } from '../../store/index'
const { NOTARIA } = useStore()
import { useUtils } from '#imports';
const { imagenIDtoSRC, $t } = useUtils()
const props = defineProps({
  "obj": Object,
  "type": String
})
const control = ref(props.obj)
watch(()=>props.obj,(n,o)=>{
  if(n && n != o){
    control.value = n
  }
})

const estiloTituloShadow = ref(control.value?.Titulo? '4px 2px 6px' + control.value.Titulo.css.BackgroundColor : '');
const estiloTituloColor = ref(control.value?.Titulo?.css?.Color ? control.value.Titulo?.css?.Color : '')

const estiloTituloFont = ref(control.value?.Titulo?.css?.Font ? control.value?.Titulo?.css?.Font : '')
const estiloTituloSize = ref(control.value?.Titulo?.css?.Size ? control.value?.Titulo?.css?.Size : '')
const estiloTituloWeight = ref(control.value?.Titulo?.css?.Weight ? control.value?.Titulo?.css?.Weight : '')
const estiloTituloAlign = ref(control.value?.Titulo?.css?.Align ? control.value?.Titulo?.css?.Align : '')

const estiloSubtituloColor = ref(control.value?.Subtitulo?.css?.Color ? control.value?.Subtitulo?.css?.Color : '')
const estiloSubtituloShadow = ref( control.value?.Subtitulo? '4px 2px 6px' + control.value.Subtitulo.css.BackgroundColor : '');
const estiloSubtituloFont = ref(control.value?.Subtitulo?.css?.Font ? control.value?.Subtitulo?.css?.Font : '')
const estiloSubtituloWeight = ref(control.value?.Subtitulo?.css?.Weight ? control.value?.Subtitulo?.css?.Weight : '')
const estiloSubtituloSize = ref(control.value?.Subtitulo?.css?.Size ? control.value?.Subtitulo?.css?.Size : '')
const estiloSubtituloAlign =ref(control.value?.Subtitulo?.css?.Align ? control.value?.Subtitulo?.css?.Align : '')

const estiloButtonColor = ref(control.value?.Button?.css?.Color ?control.value?.Button?.css?.Color :'')
const estiloButtonBackground = ref(control.value?.Button?.css?.BackgroundColor ?control.value?.Button?.css?.BackgroundColor :'')
const estiloButtonFont = ref(control.value?.Button?.css?.Font ?control.value?.Button?.css?.Font :'')
const estiloButtonSize = ref(control.value?.Button?.css?.Size ?control.value?.Button?.css?.Size :'')
const estiloButtonWeight = ref(control.value?.Button?.css?.Weight ?control.value?.Button?.css?.Weight :'')
const estiloButtonAlign = ref(control.value?.Button?.css?.Align ?control.value?.Button?.css?.Align :'')

</script>
<style>
.banner-section h1{
  color:v-bind(estiloTituloColor) !important;
  text-shadow:v-bind(estiloTituloShadow) !important;
  font-family:v-bind(estiloTituloFont) !important;
  font-size:v-bind(estiloTituloSize) !important;
  font-weight:v-bind(estiloTituloWeight) !important;
  text-align:v-bind(estiloTituloAlign) !important;
}

.banner-section h2 {
  color:v-bind(estiloSubtituloColor) !important;
  text-shadow:v-bind(estiloSubtituloShadow) !important;
  font-family:v-bind(estiloSubtituloFont) !important;
  font-size:v-bind(estiloSubtituloSize) !important;
  font-weight:v-bind(estiloSubtituloWeight) !important;
  text-align:v-bind(estiloSubtituloAlign) !important;
}

.banner-section a{
  color:v-bind(estiloButtonColor) !important;
  background-color:v-bind(estiloButtonBackground) !important;
  font-family:v-bind(estiloButtonFont) !important;
  font-size:v-bind(estiloButtonSize) !important;
  font-weight:v-bind(estiloButtonWeight) !important;
  border:v-bind(estiloButtonAlign) !important;
}

</style>